import styled from 'styled-components';
import { headline2, poppinsSemiBoldFont } from '@/styles/typography';
import { COLORS } from '@/styles/colors';
import { media } from '@/styles/responsive';

export const Header = styled.h1`
  margin: 0;
  font-size: 48px;
  line-height: 58px;
  ${poppinsSemiBoldFont};
  letter-spacing: -1px;
  color: ${COLORS.black};
  text-align: center;
  font-weight: normal;

  ${media.mobile`
    ${headline2};
  `}
`;
